import { Phone, MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { BUSINESS, telLink, waLink } from "@/data/business";

export default function FloatingContact() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/destination/")) return null;
  return (
    <div className="fixed right-4 z-40 flex flex-col gap-3 sm:right-6" style={{ bottom: "calc(1.25rem + env(safe-area-inset-bottom))" }}>
      <a
        href={telLink(BUSINESS.phoneIndiaRaw)}
        data-testid="floating-call-button"
        aria-label="Call Tingadya Travels"
        className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-ink/90 text-gold shadow-xl backdrop-blur-md transition-transform hover:scale-110"
      >
        <Phone size={19} />
      </a>
      <a
        href={waLink("Hello Tingadya Travels! I want to plan a Uttarakhand trip. Please share taxi details.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="WhatsApp Tingadya Travels"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] transition-transform hover:scale-110"
      >
        <MessageCircle size={24} />
      </a>
    </div>
  );
}
